import apiClient from './client';

// ===== Health Check =====

export const checkHealth = async (): Promise<any> => {
  const response = await apiClient.get('/health');
  return response.data;
};

// ===== Initial Data =====

export const getInitialData = async (): Promise<{
  sports: Record<string, {
    name: string;
    leagues: Array<{value: string; label: string}>;
  }>;
  aiModels: Array<{value: string; label: string}>;
  defaultAIProvider: string;
  timestamp: string;
}> => {
  const response = await apiClient.get('/api/initial-data');
  return response.data;
};
